import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { SupportedPaymentMethod } from '@mews/enums';
import { AssetLoader, PaymentCardImageTypes } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { PaymentMethodImage, PaymentMethodImageType } from '../PaymentMethodImage';
import { getSupportedImageTypes } from './helpers';

const getWrappedImageComponent =
    (assetLoader?: AssetLoader) => (type: keyof PaymentCardImageTypes | PaymentMethodImageType) => (
        <StackItem key={type} padding="50">
            <PaymentMethodImage assetLoader={assetLoader} type={type} />
        </StackItem>
    );

interface PaymentMethodListProps {
    assetLoader?: AssetLoader;
    cardTypes: Array<keyof PaymentCardImageTypes>;
    paymentMethods: Array<SupportedPaymentMethod>;
}

export const PaymentMethodList: React.FC<PaymentMethodListProps> = ({ assetLoader, cardTypes, paymentMethods }) => {
    const imageTypes = getSupportedImageTypes({ cardTypes, paymentMethods });
    if (array.isEmpty(imageTypes)) {
        return null;
    }

    return (
        <Stack wrap alignment="center" itemAlignment="center">
            {pipe(imageTypes, array.map(getWrappedImageComponent(assetLoader)))}
        </Stack>
    );
};
